import React, { useEffect } from 'react'

import { InputWrapper } from '@amzn/stencil-react-components/input'
import { View } from '@amzn/stencil-react-components/layout'
import { Select } from '@amzn/stencil-react-components/select'

import { STAGE } from 'src/config.app'
import { WbsAuthenticator } from 'src/pages/scoring-testing-v2/authentication/WbsAuthenticator'

export interface StageSelectionProps {
    designerEnv: STAGE
    showOnDesignerEnvs: STAGE[]
    wbsStageOptions: STAGE[]
    selectedWbsStage: STAGE
    setSelectedWbsStage: (stage: STAGE) => void
    width?: string
}
export const StageSelection = (props: StageSelectionProps) => {
    useEffect(() => {
        WbsAuthenticator.initCognitoAuth(props.selectedWbsStage)
        WbsAuthenticator.authenticate(() => {})
    }, [props.selectedWbsStage])

    return (
        <View width={props.width ? props.width : undefined}>
            <InputWrapper labelText='Environment' id='stage-selection-wrapper'>
                {(inputProps) => (
                    <Select
                        {...inputProps}
                        value={props.selectedWbsStage}
                        onChange={props.setSelectedWbsStage}
                        options={props.wbsStageOptions}
                        renderOption={(option: STAGE) => option.toUpperCase()}
                        disabled={!props.showOnDesignerEnvs.includes(props.designerEnv)}
                    />
                )}
            </InputWrapper>
        </View>
    )
}
